export default "__VITE_ASSET__CoQx0JvT__"